// Components
import ReconciliationUnitsEditableTable from "./ReconciliationUnitsEditableTable";

// Types
import { GridColDef } from "@mui/x-data-grid-pro";
import { ClassNameHints } from "@Common/types/tables";
import { TExtraTableProps } from "@/DataPages/types/inventory/commons";

type UnitsOnScheduleTableProps = Readonly<{
	locationId: string;
	commissionCycleId: string;
	payPeriodId: string;
	extraTableProps?: TExtraTableProps;
	hasNextPage: boolean;
}>;

const columns: (GridColDef & { hints?: Partial<ClassNameHints> })[] = [
	{ field: "_id", headerName: "ID" },
	{ field: "status", width: 45, headerName: "" },
	{ field: "type", headerName: "Type", width: 60 },
	{ field: "vinNumber", headerName: "VIN", width: 120 },
	{ field: "stockNumber", headerName: "Stock #", width: 80 },
	{ field: "balance", headerName: "Balance", align: "right", type: "number", hints: { isMoney: true }, width: 100 },
	{
		field: "year",
		headerName: "Year",
		type: "number",
		headerAlign: "right",
		align: "right",
		width: 60,
	},
	{
		field: "manuallyReconciled",
		headerName: "",
		editable: true,
	},
	{
		field: "_empty",
		headerName: "",
		width: 10,
	},
	{ field: "make", headerName: "Make", width: 110 },
	{ field: "model", headerName: "Model", width: 110 },
	{ field: "color", headerName: "Color" },
	{ field: "name", headerName: "Lot/Address", width: 80 },
	{
		field: "reason",
		headerName: "Reason",
		width: 140,
		editable: true,
	},
	{
		field: "resolution",
		headerName: "Resolution",
		width: 140,
		editable: true,
	},
	{
		field: "notes",
		headerName: "Notes",
		headerAlign: "right",
		align: "right",
		width: 80,
		editable: true,
	},
];

export default function UnitsOnScheduleTable(props: UnitsOnScheduleTableProps) {
	const { extraTableProps, locationId, commissionCycleId, payPeriodId, hasNextPage } = props;
	return (
		<ReconciliationUnitsEditableTable
			columns={columns}
			extraTableProps={extraTableProps}
			locationId={locationId}
			commissionCycleId={commissionCycleId}
			payPeriodId={payPeriodId}
			hasNextPage={hasNextPage}
			table="onSchedule"
		/>
	);
}
